<form [formGroup]="avform">
	<mat-form-field style="width: 100%">
		<mat-label *ngIf="personDisplayProps.isVisible">{{ personDisplayProps?.label }}</mat-label>
		<input
			*ngIf="!searchOpen"
			matNativeControl
			formControlName="personDisplay"
			(click)="openPersonSearch()"
			readonly="readonly"
		/>
		<!--holds the person name, is displayed if search is not open-->
		<input *ngIf="searchOpen" matNativeControl formControlName="personDisplay" readonly="readonly" />
		<!--holds the person name, is displayed if search is open-->
		<input type="hidden" formControlName="person" [readonly]="searchOpen" />
		<!--holds the person object-->
		<button
			*ngIf="avform?.get('personDisplay').value && !readonly"
			class="clear-field-button"
			matSuffix
			mat-icon-button
			matTooltip="Clear"
			(click)="removePerson()"
		>
			<fa-icon [icon]="$any(['fass', 'times-circle'])"></fa-icon>
		</button>
		<!--ERROR-->
		<mat-error [id]="field.id + '_error'">
			<formly-validation-message [field]="field"></formly-validation-message>
		</mat-error>
	</mat-form-field>
</form>
<input [id]="field.id" [name]="field.id" type="hidden" [formControl]="formControl" [formlyAttributes]="field" />
